'use strict';
const assert = require('assert');
const AuthenticationManager = require('../authentication-manager');
const RequestConfigurationManager = require('../request-configuration-manager');
const chai = require('chai');

const expect = chai.expect;
/* eslint-disable  no-undef */ /* eslint-disable  no-unused-vars */
const fakeSdkConfiguration = {
  PartnerServiceApiRoot: 'https://api.partnercenter.microsoft.com',
  Apis: {
    UserCredentials: {
      Path: 'https://login.windows.net/{0}/oauth2/token',
      Method: 'POST',
      Authorization: true,
      PathParams: {
        Domain: 'default',
      },
      Parameters: {
        resource: 'https://api.partnercenter.microsoft.com',
        client_id: 'default',
        grant_type: 'password',
        username: 'default',
        password: 'default',
        scope: 'openid',
      },
    },
  },
};

const fakeCredentials = {
  domain: 'csDesarrollo.onmicrosoft.com',
  clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
  userName: 'app@csDesarrollo.onmicrosoft.com',
  password: 'Inn0vaci0n',
};


describe('AuthenticationManager', () => {
  it('Creates the correct instance of the class', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const requestConfigurationManager = new RequestConfigurationManager(fakeSdkConfiguration, fakeRequest, fakeCredentials);
    const authenticationManager = new AuthenticationManager(requestConfigurationManager);
    expect(authenticationManager).to.have.property('requestConfigurationManager');
    expect(authenticationManager.requestConfigurationManager).to.have.property('sdkConfiguration');
    expect(authenticationManager.requestConfigurationManager).to.have.property('credentials');
    expect(authenticationManager.requestConfigurationManager).to.have.property('request');
    done();
  });
  it('requestAuthentication, must return the promise for the authentication request', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const requestConfigurationManager = new RequestConfigurationManager(fakeSdkConfiguration, fakeRequest, fakeCredentials);
    const auth = new AuthenticationManager(requestConfigurationManager);
    auth.requestAuthentication().then((result) => {
      assert(result.method === 'POST');
      assert(result.uri === 'https://login.windows.net/csDesarrollo.onmicrosoft.com/oauth2/token');
      assert(result.form.resource === 'https://api.partnercenter.microsoft.com');
      assert(result.form.client_id === 'f7d796b6-c2fe-4e70-b17f-e5d919695487');
      assert(result.form.grant_type === 'password');
      assert(result.form.username === 'app@csDesarrollo.onmicrosoft.com');
      assert(result.form.password === 'Inn0vaci0n');
      assert(result.form.scope === 'openid');
      assert(result.headers.Accept === 'application/json');
    }).then(done, done);
  });
  it('tokenRefresh, if token is not set, creats one', (done) => {
    const fakeRequest = options => Promise.resolve({ access_token: 'fake access token' });
    const requestConfigurationManager = new RequestConfigurationManager(fakeSdkConfiguration, fakeRequest, fakeCredentials);
    const auth = new AuthenticationManager(requestConfigurationManager);
    auth.tokenRefresh().then((fakeAccessToken) => {
      assert(fakeAccessToken === 'fake access token');
    }).then(done, done);
  });
  it('tokenRefresh, if token is set and is expired, creats one', (done) => {
    global.Token = {
      access_token: 'fake expired access token',
      expires_on: 1484942566,
    };
    const fakeRequest = options => Promise.resolve({ access_token: 'fake refreshed access token', expires_on: 1484942566 });
    const requestConfigurationManager = new RequestConfigurationManager(fakeSdkConfiguration, fakeRequest, fakeCredentials);
    const auth = new AuthenticationManager(requestConfigurationManager);
    auth.tokenRefresh().then((fakeAccessToken) => {
      assert(fakeAccessToken === 'fake refreshed access token');
    }).then(done, done);
  });
  it('tokenRefresh, if token is set and is not expired, returns token in the global object', (done) => {
    global.Token = {
      access_token: 'fake working access token',
      expires_on: 9484942566,
    };
    const fakeRequest = options => Promise.resolve({ access_token: 'fake refreshed access token', expires_on: 1484942566 });
    const requestConfigurationManager = new RequestConfigurationManager(fakeSdkConfiguration, fakeRequest, fakeCredentials);
    const auth = new AuthenticationManager(requestConfigurationManager);
    auth.tokenRefresh().then((fakeAccessToken) => {
      assert(fakeAccessToken === 'fake working access token');
    }).then(done, done);
  });
});

